<template>
<div class="chapter">
<div class="inner_page">
<div id="fm_03">
<p class="title"><span>Crush</span></p>
<p class="title1">AN EROTIC NOVEL</p>
<p class="title2">Cécile de La Baume</p>
<p class="title3">TRANSLATED FROM THE FRENCH BY</p>
<p class="title4">RAMONA DESFLEURS</p>
<p class="title4a"><img alt="" class="imgepub" src="images/img_0001.jpg"/></p>
<p class="title5">GROVE PRESS</p>
<p class="title6"><span>New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0f07f26a